import Vue from 'vue';
import Vuex from 'vuex';
import { authModule } from '../core/auth/store/auth';
import { propertiesModule } from './modules/properties';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth: authModule,
        properties: propertiesModule
    }
});

